import SubadminTable from './SubadminTable'

export default SubadminTable
